import { IColor } from "../types/product.types";

export const getSplitBackground = (color: IColor) => {
  const hexArray = color.hex;
  if (!Array.isArray(hexArray) || hexArray.length === 0) return "#000000";
  if (hexArray.length === 1) return hexArray[0];
  const stops = hexArray.map(
    (hex, i) =>
      `${hex} ${(i / hexArray.length) * 100}% ${
        ((i + 1) / hexArray.length) * 100
      }%`
  );
  return `linear-gradient(to bottom, ${stops.join(", ")})`;
};